import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Image,
  Spinner,
  Modal,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
import { Mail } from "react-feather";

import { useNotification } from "../../components/notification";
import apiService from "../../services/apiService";

import logo from "../../logo.png";

const RecoverPasswordConfirmation = () => {
  const { showNotification } = useNotification();
  const [isPageLoading, setIsPageLoading] = useState(false);

  // Get the email from location state
  const location = useLocation();
  const email = location.state?.email;

  const handleResendEmail = async () => {
    try {
      setIsPageLoading(true);
      const response = await apiService.post("/auth/forgot-password", {
        email,
      });
      showNotification("success", response.message, 5000);
    } catch (error) {
      showNotification(
        "danger",
        error.message || "Failed to resend recovery email.",
        5000
      );
    } finally {
      setIsPageLoading(false);
    }
  };

  return (
    <Container className="min-vh-100 d-flex align-items-center justify-content-center flex-column">
      <Row>
        <Col xs={12} className="text-center mb-4">
          <Image
            src={logo}
            alt={`${process.env.REACT_APP_PORTAL}`}
            fluid
            width="225px"
          />
        </Col>
        <Col xs={11} md={9} lg={7} xl={6} xxl={5} className="m-auto">
          <Card className="p-4 shadow border-0">
            <Card.Body className="text-center">
              <Mail size={40} className="text-secondary mb-3" />
              <h1 className="text-center mb-3 fs-5">Check your email</h1>
              <p className="text-center mb-4 text-light-emphasis fw-light">
                Password reset instructions have been sent to{" "}
                <span className="text-primary fw-bold">{email}</span>. Check
                your Spam/Junk folders if not received in 10 minutes.
              </p>
              <hr className="mt-5 mb-4" />
              <div className="text-center text-light-emphasis fw-light fs-medium">
                Didn't receive the link?
                <Link
                  onClick={handleResendEmail}
                  className="text-decoration-none link-primary fw-semibold "
                >
                  {" "}
                  Resend
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={isPageLoading}
        aria-labelledby="Loading"
        className="modal-loading"
        contentClassName="bg-transparent border-0"
        centered
      >
        <Modal.Body className="text-center">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default RecoverPasswordConfirmation;